export default __webpack_public_path__ + "static/media/laliga-logo-horizontal_EN.97476ab5.svg";